import { Checkbox, FormControlLabel } from '@mui/material'
import { ChangeEvent } from 'react'

interface CustomCheckboxLabelProps {
  checked: boolean
  label: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const CustomCheckboxLabel = ({ checked: isChecked, onChange, label: labelText }: CustomCheckboxLabelProps) => (
  <FormControlLabel control={<Checkbox checked={isChecked} onChange={onChange} />} label={labelText} />
)

export default CustomCheckboxLabel
